// Italian municipalities data for autocomplete
// This includes major cities and municipalities across Italy

export interface Municipality {
  name: string;
  province: string;
  region: string;
  fullName: string; // "Comune, Provincia"
}

export const italianMunicipalities: Municipality[] = [
  // Lombardia
  { name: "Milano", province: "MI", region: "Lombardia", fullName: "Milano, MI" },
  { name: "Bergamo", province: "BG", region: "Lombardia", fullName: "Bergamo, BG" },
  { name: "Brescia", province: "BS", region: "Lombardia", fullName: "Brescia, BS" },
  { name: "Como", province: "CO", region: "Lombardia", fullName: "Como, CO" },
  { name: "Cremona", province: "CR", region: "Lombardia", fullName: "Cremona, CR" },
  { name: "Lecco", province: "LC", region: "Lombardia", fullName: "Lecco, LC" },
  { name: "Lodi", province: "LO", region: "Lombardia", fullName: "Lodi, LO" },
  { name: "Mantova", province: "MN", region: "Lombardia", fullName: "Mantova, MN" },
  { name: "Monza", province: "MB", region: "Lombardia", fullName: "Monza, MB" },
  { name: "Pavia", province: "PV", region: "Lombardia", fullName: "Pavia, PV" },
  { name: "Sondrio", province: "SO", region: "Lombardia", fullName: "Sondrio, SO" },
  { name: "Varese", province: "VA", region: "Lombardia", fullName: "Varese, VA" },
  { name: "Sesto San Giovanni", province: "MI", region: "Lombardia", fullName: "Sesto San Giovanni, MI" },
  { name: "Cinisello Balsamo", province: "MI", region: "Lombardia", fullName: "Cinisello Balsamo, MI" },
  { name: "Legnano", province: "MI", region: "Lombardia", fullName: "Legnano, MI" },
  { name: "Rho", province: "MI", region: "Lombardia", fullName: "Rho, MI" },
  { name: "Cologno Monzese", province: "MI", region: "Lombardia", fullName: "Cologno Monzese, MI" },
  { name: "Paderno Dugnano", province: "MI", region: "Lombardia", fullName: "Paderno Dugnano, MI" },
  { name: "Rozzano", province: "MI", region: "Lombardia", fullName: "Rozzano, MI" },
  { name: "San Giuliano Milanese", province: "MI", region: "Lombardia", fullName: "San Giuliano Milanese, MI" },
  { name: "Pioltello", province: "MI", region: "Lombardia", fullName: "Pioltello, MI" },
  { name: "Cernusco sul Naviglio", province: "MI", region: "Lombardia", fullName: "Cernusco sul Naviglio, MI" },
  { name: "Segrate", province: "MI", region: "Lombardia", fullName: "Segrate, MI" },
  { name: "San Donato Milanese", province: "MI", region: "Lombardia", fullName: "San Donato Milanese, MI" },
  { name: "Lissone", province: "MB", region: "Lombardia", fullName: "Lissone, MB" },
  { name: "Desio", province: "MB", region: "Lombardia", fullName: "Desio, MB" },
  { name: "Cesano Maderno", province: "MB", region: "Lombardia", fullName: "Cesano Maderno, MB" },
  { name: "Seregno", province: "MB", region: "Lombardia", fullName: "Seregno, MB" },
  { name: "Giussano", province: "MB", region: "Lombardia", fullName: "Giussano, MB" },
  { name: "Brugherio", province: "MB", region: "Lombardia", fullName: "Brugherio, MB" },
  { name: "Meda", province: "MB", region: "Lombardia", fullName: "Meda, MB" },
  { name: "Vimercate", province: "MB", region: "Lombardia", fullName: "Vimercate, MB" },
  { name: "Carate Brianza", province: "MB", region: "Lombardia", fullName: "Carate Brianza, MB" },
  { name: "Nova Milanese", province: "MB", region: "Lombardia", fullName: "Nova Milanese, MB" },
  { name: "Cantù", province: "CO", region: "Lombardia", fullName: "Cantù, CO" },
  { name: "Mariano Comense", province: "CO", region: "Lombardia", fullName: "Mariano Comense, CO" },
  { name: "Erba", province: "CO", region: "Lombardia", fullName: "Erba, CO" },
  { name: "Olgiate Comasco", province: "CO", region: "Lombardia", fullName: "Olgiate Comasco, CO" },
  { name: "Fino Mornasco", province: "CO", region: "Lombardia", fullName: "Fino Mornasco, CO" },
  { name: "Lurate Caccivio", province: "CO", region: "Lombardia", fullName: "Lurate Caccivio, CO" },
  { name: "Inverigo", province: "CO", region: "Lombardia", fullName: "Inverigo, CO" },
  { name: "Turate", province: "CO", region: "Lombardia", fullName: "Turate, CO" },
  { name: "Cermenate", province: "CO", region: "Lombardia", fullName: "Cermenate, CO" },
  { name: "Lomazzo", province: "CO", region: "Lombardia", fullName: "Lomazzo, CO" },
  { name: "Rovellasca", province: "CO", region: "Lombardia", fullName: "Rovellasca, CO" },
  { name: "Rovello Porro", province: "CO", region: "Lombardia", fullName: "Rovello Porro, CO" },
  { name: "Bregnano", province: "CO", region: "Lombardia", fullName: "Bregnano, CO" },
  { name: "Vertemate con Minoprio", province: "CO", region: "Lombardia", fullName: "Vertemate con Minoprio, CO" },
  { name: "Cadorago", province: "CO", region: "Lombardia", fullName: "Cadorago, CO" },
  { name: "Guanzate", province: "CO", region: "Lombardia", fullName: "Guanzate, CO" },

  // Lazio
  { name: "Roma", province: "RM", region: "Lazio", fullName: "Roma, RM" },
  { name: "Frosinone", province: "FR", region: "Lazio", fullName: "Frosinone, FR" },
  { name: "Latina", province: "LT", region: "Lazio", fullName: "Latina, LT" },
  { name: "Rieti", province: "RI", region: "Lazio", fullName: "Rieti, RI" },
  { name: "Viterbo", province: "VT", region: "Lazio", fullName: "Viterbo, VT" },
  { name: "Guidonia Montecelio", province: "RM", region: "Lazio", fullName: "Guidonia Montecelio, RM" },
  { name: "Aprilia", province: "LT", region: "Lazio", fullName: "Aprilia, LT" },
  { name: "Cisterna di Latina", province: "LT", region: "Lazio", fullName: "Cisterna di Latina, LT" },
  { name: "Velletri", province: "RM", region: "Lazio", fullName: "Velletri, RM" },
  { name: "Civitavecchia", province: "RM", region: "Lazio", fullName: "Civitavecchia, RM" },
  { name: "Fiumicino", province: "RM", region: "Lazio", fullName: "Fiumicino, RM" },
  { name: "Tivoli", province: "RM", region: "Lazio", fullName: "Tivoli, RM" },
  { name: "Ardea", province: "RM", region: "Lazio", fullName: "Ardea, RM" },
  { name: "Pomezia", province: "RM", region: "Lazio", fullName: "Pomezia, RM" },
  { name: "Albano Laziale", province: "RM", region: "Lazio", fullName: "Albano Laziale, RM" },
  { name: "Marino", province: "RM", region: "Lazio", fullName: "Marino, RM" },
  { name: "Monterotondo", province: "RM", region: "Lazio", fullName: "Monterotondo, RM" },
  { name: "Ladispoli", province: "RM", region: "Lazio", fullName: "Ladispoli, RM" },
  { name: "Cerveteri", province: "RM", region: "Lazio", fullName: "Cerveteri, RM" },
  { name: "Anzio", province: "RM", region: "Lazio", fullName: "Anzio, RM" },
  { name: "Nettuno", province: "RM", region: "Lazio", fullName: "Nettuno, RM" },
  { name: "Terracina", province: "LT", region: "Lazio", fullName: "Terracina, LT" },
  { name: "Formia", province: "LT", region: "Lazio", fullName: "Formia, LT" },
  { name: "Gaeta", province: "LT", region: "Lazio", fullName: "Gaeta, LT" },
  { name: "Sora", province: "FR", region: "Lazio", fullName: "Sora, FR" },
  { name: "Cassino", province: "FR", region: "Lazio", fullName: "Cassino, FR" },
  { name: "Frosinone", province: "FR", region: "Lazio", fullName: "Frosinone, FR" },
  { name: "Alatri", province: "FR", region: "Lazio", fullName: "Alatri, FR" },
  { name: "Ceccano", province: "FR", region: "Lazio", fullName: "Ceccano, FR" },
  { name: "Veroli", province: "FR", region: "Lazio", fullName: "Veroli, FR" },
  { name: "Ferentino", province: "FR", region: "Lazio", fullName: "Ferentino, FR" },
  { name: "Anagni", province: "FR", region: "Lazio", fullName: "Anagni, FR" },
  { name: "Rieti", province: "RI", region: "Lazio", fullName: "Rieti, RI" },
  { name: "Cittaducale", province: "RI", region: "Lazio", fullName: "Cittaducale, RI" },
  { name: "Viterbo", province: "VT", region: "Lazio", fullName: "Viterbo, VT" },
  { name: "Civitavecchia", province: "VT", region: "Lazio", fullName: "Civitavecchia, VT" },
  { name: "Tarquinia", province: "VT", region: "Lazio", fullName: "Tarquinia, VT" },
  { name: "Vetralla", province: "VT", region: "Lazio", fullName: "Vetralla, VT" },
  { name: "Montefiascone", province: "VT", region: "Lazio", fullName: "Montefiascone, VT" },
  { name: "Bagnoregio", province: "VT", region: "Lazio", fullName: "Bagnoregio, VT" },
  { name: "Orte", province: "VT", region: "Lazio", fullName: "Orte, VT" },
  { name: "Capranica", province: "VT", region: "Lazio", fullName: "Capranica, VT" },
  { name: "Ronciglione", province: "VT", region: "Lazio", fullName: "Ronciglione, VT" },
  { name: "Nepi", province: "VT", region: "Lazio", fullName: "Nepi, VT" },
  { name: "Sutri", province: "VT", region: "Lazio", fullName: "Sutri, VT" },
  { name: "Caprarola", province: "VT", region: "Lazio", fullName: "Caprarola, VT" },
  { name: "Fabrica di Roma", province: "VT", region: "Lazio", fullName: "Fabrica di Roma, VT" },
  { name: "Canepina", province: "VT", region: "Lazio", fullName: "Canepina, VT" },
  { name: "Soriano nel Cimino", province: "VT", region: "Lazio", fullName: "Soriano nel Cimino, VT" },
  { name: "Vignanello", province: "VT", region: "Lazio", fullName: "Vignanello, VT" },
  { name: "Gallese", province: "VT", region: "Lazio", fullName: "Gallese, VT" },
  { name: "Bassano in Teverina", province: "VT", region: "Lazio", fullName: "Bassano in Teverina, VT" },
  { name: "Attigliano", province: "TR", region: "Umbria", fullName: "Attigliano, TR" },
  { name: "Alviano", province: "TR", region: "Umbria", fullName: "Alviano, TR" },
  { name: "Baschi", province: "TR", region: "Umbria", fullName: "Baschi, TR" },
  { name: "Calvi dell'Umbria", province: "TR", region: "Umbria", fullName: "Calvi dell'Umbria, TR" },
  { name: "Castel Giorgio", province: "TR", region: "Umbria", fullName: "Castel Giorgio, TR" },
  { name: "Castel Viscardo", province: "TR", region: "Umbria", fullName: "Castel Viscardo, TR" },
  { name: "Fabro", province: "TR", region: "Umbria", fullName: "Fabro, TR" },
  { name: "Ferentillo", province: "TR", region: "Umbria", fullName: "Ferentillo, TR" },
  { name: "Ficulle", province: "TR", region: "Umbria", fullName: "Ficulle, TR" },
  { name: "Giove", province: "TR", region: "Umbria", fullName: "Giove, TR" },
  { name: "Guardea", province: "TR", region: "Umbria", fullName: "Guardea, TR" },
  { name: "Lugnano in Teverina", province: "TR", region: "Umbria", fullName: "Lugnano in Teverina, TR" },
  { name: "Montecastrilli", province: "TR", region: "Umbria", fullName: "Montecastrilli, TR" },
  { name: "Montecchio", province: "TR", region: "Umbria", fullName: "Montecchio, TR" },
  { name: "Montefranco", province: "TR", region: "Umbria", fullName: "Montefranco, TR" },
  { name: "Montegabbione", province: "TR", region: "Umbria", fullName: "Montegabbione, TR" },
  { name: "Monteleone d'Orvieto", province: "TR", region: "Umbria", fullName: "Monteleone d'Orvieto, TR" },
  { name: "Narni", province: "TR", region: "Umbria", fullName: "Narni, TR" },
  { name: "Orvieto", province: "TR", region: "Umbria", fullName: "Orvieto, TR" },
  { name: "Otricoli", province: "TR", region: "Umbria", fullName: "Otricoli, TR" },
  { name: "Parrano", province: "TR", region: "Umbria", fullName: "Parrano, TR" },
  { name: "Penna in Teverina", province: "TR", region: "Umbria", fullName: "Penna in Teverina, TR" },
  { name: "Polino", province: "TR", region: "Umbria", fullName: "Polino, TR" },
  { name: "Porano", province: "TR", region: "Umbria", fullName: "Porano, TR" },
  { name: "San Gemini", province: "TR", region: "Umbria", fullName: "San Gemini, TR" },
  { name: "San Venanzo", province: "TR", region: "Umbria", fullName: "San Venanzo, TR" },
  { name: "Stroncone", province: "TR", region: "Umbria", fullName: "Stroncone, TR" },
  { name: "Terni", province: "TR", region: "Umbria", fullName: "Terni, TR" },
  { name: "Avigliano Umbro", province: "TR", region: "Umbria", fullName: "Avigliano Umbro, TR" },
  { name: "Acquasparta", province: "TR", region: "Umbria", fullName: "Acquasparta, TR" },
  { name: "Allerona", province: "TR", region: "Umbria", fullName: "Allerona, TR" },
  { name: "Arrone", province: "TR", region: "Umbria", fullName: "Arrone, TR" },
  { name: "Castel Ritaldi", province: "PG", region: "Umbria", fullName: "Castel Ritaldi, PG" },
  { name: "Castiglione del Lago", province: "PG", region: "Umbria", fullName: "Castiglione del Lago, PG" },
  { name: "Città della Pieve", province: "PG", region: "Umbria", fullName: "Città della Pieve, PG" },
  { name: "Città di Castello", province: "PG", region: "Umbria", fullName: "Città di Castello, PG" },
  { name: "Collazzone", province: "PG", region: "Umbria", fullName: "Collazzone, PG" },
  { name: "Corciano", province: "PG", region: "Umbria", fullName: "Corciano, PG" },
  { name: "Costacciaro", province: "PG", region: "Umbria", fullName: "Costacciaro, PG" },
  { name: "Deruta", province: "PG", region: "Umbria", fullName: "Deruta, PG" },
  { name: "Foligno", province: "PG", region: "Umbria", fullName: "Foligno, PG" },
  { name: "Fossato di Vico", province: "PG", region: "Umbria", fullName: "Fossato di Vico, PG" },
  { name: "Fratta Todina", province: "PG", region: "Umbria", fullName: "Fratta Todina, PG" },
  { name: "Giano dell'Umbria", province: "PG", region: "Umbria", fullName: "Giano dell'Umbria, PG" },
  { name: "Gualdo Cattaneo", province: "PG", region: "Umbria", fullName: "Gualdo Cattaneo, PG" },
  { name: "Gualdo Tadino", province: "PG", region: "Umbria", fullName: "Gualdo Tadino, PG" },
  { name: "Gubbio", province: "PG", region: "Umbria", fullName: "Gubbio, PG" },
  { name: "Lisciano Niccone", province: "PG", region: "Umbria", fullName: "Lisciano Niccone, PG" },
  { name: "Magione", province: "PG", region: "Umbria", fullName: "Magione, PG" },
  { name: "Marsciano", province: "PG", region: "Umbria", fullName: "Marsciano, PG" },
  { name: "Massa Martana", province: "PG", region: "Umbria", fullName: "Massa Martana, PG" },
  { name: "Monte Castello di Vibio", province: "PG", region: "Umbria", fullName: "Monte Castello di Vibio, PG" },
  { name: "Montefalco", province: "PG", region: "Umbria", fullName: "Montefalco, PG" },
  { name: "Monteleone di Spoleto", province: "PG", region: "Umbria", fullName: "Monteleone di Spoleto, PG" },
  { name: "Monte Santa Maria Tiberina", province: "PG", region: "Umbria", fullName: "Monte Santa Maria Tiberina, PG" },
  { name: "Montone", province: "PG", region: "Umbria", fullName: "Montone, PG" },
  { name: "Nocera Umbra", province: "PG", region: "Umbria", fullName: "Nocera Umbra, PG" },
  { name: "Norcia", province: "PG", region: "Umbria", fullName: "Norcia, PG" },
  { name: "Paciano", province: "PG", region: "Umbria", fullName: "Paciano, PG" },
  { name: "Panicale", province: "PG", region: "Umbria", fullName: "Panicale, PG" },
  { name: "Passignano sul Trasimeno", province: "PG", region: "Umbria", fullName: "Passignano sul Trasimeno, PG" },
  { name: "Perugia", province: "PG", region: "Umbria", fullName: "Perugia, PG" },
  { name: "Piegaro", province: "PG", region: "Umbria", fullName: "Piegaro, PG" },
  { name: "Pietralunga", province: "PG", region: "Umbria", fullName: "Pietralunga, PG" },
  { name: "Poggiodomo", province: "PG", region: "Umbria", fullName: "Poggiodomo, PG" },
  { name: "Preci", province: "PG", region: "Umbria", fullName: "Preci, PG" },
  { name: "San Giustino", province: "PG", region: "Umbria", fullName: "San Giustino, PG" },
  { name: "Sant'Anatolia di Narco", province: "PG", region: "Umbria", fullName: "Sant'Anatolia di Narco, PG" },
  { name: "Scheggia e Pascelupo", province: "PG", region: "Umbria", fullName: "Scheggia e Pascelupo, PG" },
  { name: "Scheggino", province: "PG", region: "Umbria", fullName: "Scheggino, PG" },
  { name: "Sellano", province: "PG", region: "Umbria", fullName: "Sellano, PG" },
  { name: "Sigillo", province: "PG", region: "Umbria", fullName: "Sigillo, PG" },
  { name: "Spello", province: "PG", region: "Umbria", fullName: "Spello, PG" },
  { name: "Spoleto", province: "PG", region: "Umbria", fullName: "Spoleto, PG" },
  { name: "Todi", province: "PG", region: "Umbria", fullName: "Todi, PG" },
  { name: "Torgiano", province: "PG", region: "Umbria", fullName: "Torgiano, PG" },
  { name: "Trevi", province: "PG", region: "Umbria", fullName: "Trevi, PG" },
  { name: "Tuoro sul Trasimeno", province: "PG", region: "Umbria", fullName: "Tuoro sul Trasimeno, PG" },
  { name: "Umbertide", province: "PG", region: "Umbria", fullName: "Umbertide, PG" },
  { name: "Valfabbrica", province: "PG", region: "Umbria", fullName: "Valfabbrica, PG" },
  { name: "Vallo di Nera", province: "PG", region: "Umbria", fullName: "Vallo di Nera, PG" },
  { name: "Valtopina", province: "PG", region: "Umbria", fullName: "Valtopina, PG" },

  // Campania
  { name: "Napoli", province: "NA", region: "Campania", fullName: "Napoli, NA" },
  { name: "Avellino", province: "AV", region: "Campania", fullName: "Avellino, AV" },
  { name: "Benevento", province: "BN", region: "Campania", fullName: "Benevento, BN" },
  { name: "Caserta", province: "CE", region: "Campania", fullName: "Caserta, CE" },
  { name: "Salerno", province: "SA", region: "Campania", fullName: "Salerno, SA" },

  // Piemonte
  { name: "Torino", province: "TO", region: "Piemonte", fullName: "Torino, TO" },
  { name: "Alessandria", province: "AL", region: "Piemonte", fullName: "Alessandria, AL" },
  { name: "Asti", province: "AT", region: "Piemonte", fullName: "Asti, AT" },
  { name: "Biella", province: "BI", region: "Piemonte", fullName: "Biella, BI" },
  { name: "Cuneo", province: "CN", region: "Piemonte", fullName: "Cuneo, CN" },
  { name: "Novara", province: "NO", region: "Piemonte", fullName: "Novara, NO" },
  { name: "Verbano-Cusio-Ossola", province: "VB", region: "Piemonte", fullName: "Verbano-Cusio-Ossola, VB" },
  { name: "Vercelli", province: "VC", region: "Piemonte", fullName: "Vercelli, VC" },

  // Sicilia
  { name: "Palermo", province: "PA", region: "Sicilia", fullName: "Palermo, PA" },
  { name: "Agrigento", province: "AG", region: "Sicilia", fullName: "Agrigento, AG" },
  { name: "Caltanissetta", province: "CL", region: "Sicilia", fullName: "Caltanissetta, CL" },
  { name: "Catania", province: "CT", region: "Sicilia", fullName: "Catania, CT" },
  { name: "Enna", province: "EN", region: "Sicilia", fullName: "Enna, EN" },
  { name: "Messina", province: "ME", region: "Sicilia", fullName: "Messina, ME" },
  { name: "Ragusa", province: "RG", region: "Sicilia", fullName: "Ragusa, RG" },
  { name: "Siracusa", province: "SR", region: "Sicilia", fullName: "Siracusa, SR" },
  { name: "Trapani", province: "TP", region: "Sicilia", fullName: "Trapani, TP" },

  // Liguria
  { name: "Genova", province: "GE", region: "Liguria", fullName: "Genova, GE" },
  { name: "Imperia", province: "IM", region: "Liguria", fullName: "Imperia, IM" },
  { name: "La Spezia", province: "SP", region: "Liguria", fullName: "La Spezia, SP" },
  { name: "Savona", province: "SV", region: "Liguria", fullName: "Savona, SV" },

  // Emilia-Romagna
  { name: "Bologna", province: "BO", region: "Emilia-Romagna", fullName: "Bologna, BO" },
  { name: "Ferrara", province: "FE", region: "Emilia-Romagna", fullName: "Ferrara, FE" },
  { name: "Forlì-Cesena", province: "FC", region: "Emilia-Romagna", fullName: "Forlì-Cesena, FC" },
  { name: "Modena", province: "MO", region: "Emilia-Romagna", fullName: "Modena, MO" },
  { name: "Parma", province: "PR", region: "Emilia-Romagna", fullName: "Parma, PR" },
  { name: "Piacenza", province: "PC", region: "Emilia-Romagna", fullName: "Piacenza, PC" },
  { name: "Ravenna", province: "RA", region: "Emilia-Romagna", fullName: "Ravenna, RA" },
  { name: "Reggio Emilia", province: "RE", region: "Emilia-Romagna", fullName: "Reggio Emilia, RE" },
  { name: "Rimini", province: "RN", region: "Emilia-Romagna", fullName: "Rimini, RN" },

  // Toscana
  { name: "Firenze", province: "FI", region: "Toscana", fullName: "Firenze, FI" },
  { name: "Arezzo", province: "AR", region: "Toscana", fullName: "Arezzo, AR" },
  { name: "Grosseto", province: "GR", region: "Toscana", fullName: "Grosseto, GR" },
  { name: "Livorno", province: "LI", region: "Toscana", fullName: "Livorno, LI" },
  { name: "Lucca", province: "LU", region: "Toscana", fullName: "Lucca, LU" },
  { name: "Massa-Carrara", province: "MS", region: "Toscana", fullName: "Massa-Carrara, MS" },
  { name: "Pisa", province: "PI", region: "Toscana", fullName: "Pisa, PI" },
  { name: "Pistoia", province: "PT", region: "Toscana", fullName: "Pistoia, PT" },
  { name: "Prato", province: "PO", region: "Toscana", fullName: "Prato, PO" },
  { name: "Siena", province: "SI", region: "Toscana", fullName: "Siena, SI" },

  // Puglia
  { name: "Bari", province: "BA", region: "Puglia", fullName: "Bari, BA" },
  { name: "Brindisi", province: "BR", region: "Puglia", fullName: "Brindisi, BR" },
  { name: "Foggia", province: "FG", region: "Puglia", fullName: "Foggia, FG" },
  { name: "Lecce", province: "LE", region: "Puglia", fullName: "Lecce, LE" },
  { name: "Taranto", province: "TA", region: "Puglia", fullName: "Taranto, TA" },
  { name: "Barletta-Andria-Trani", province: "BT", region: "Puglia", fullName: "Barletta-Andria-Trani, BT" },

  // Veneto
  { name: "Venezia", province: "VE", region: "Veneto", fullName: "Venezia, VE" },
  { name: "Belluno", province: "BL", region: "Veneto", fullName: "Belluno, BL" },
  { name: "Padova", province: "PD", region: "Veneto", fullName: "Padova, PD" },
  { name: "Rovigo", province: "RO", region: "Veneto", fullName: "Rovigo, RO" },
  { name: "Treviso", province: "TV", region: "Veneto", fullName: "Treviso, TV" },
  { name: "Verona", province: "VR", region: "Veneto", fullName: "Verona, VR" },
  { name: "Vicenza", province: "VI", region: "Veneto", fullName: "Vicenza, VI" },

  // Friuli-Venezia Giulia
  { name: "Trieste", province: "TS", region: "Friuli-Venezia Giulia", fullName: "Trieste, TS" },
  { name: "Gorizia", province: "GO", region: "Friuli-Venezia Giulia", fullName: "Gorizia, GO" },
  { name: "Pordenone", province: "PN", region: "Friuli-Venezia Giulia", fullName: "Pordenone, PN" },
  { name: "Udine", province: "UD", region: "Friuli-Venezia Giulia", fullName: "Udine, UD" },

  // Trentino-Alto Adige
  { name: "Trento", province: "TN", region: "Trentino-Alto Adige", fullName: "Trento, TN" },
  { name: "Bolzano", province: "BZ", region: "Trentino-Alto Adige", fullName: "Bolzano, BZ" },

  // Marche
  { name: "Ancona", province: "AN", region: "Marche", fullName: "Ancona, AN" },
  { name: "Ascoli Piceno", province: "AP", region: "Marche", fullName: "Ascoli Piceno, AP" },
  { name: "Fermo", province: "FM", region: "Marche", fullName: "Fermo, FM" },
  { name: "Macerata", province: "MC", region: "Marche", fullName: "Macerata, MC" },
  { name: "Pesaro e Urbino", province: "PU", region: "Marche", fullName: "Pesaro e Urbino, PU" },

  // Abruzzo
  { name: "L'Aquila", province: "AQ", region: "Abruzzo", fullName: "L'Aquila, AQ" },
  { name: "Chieti", province: "CH", region: "Abruzzo", fullName: "Chieti, CH" },
  { name: "Pescara", province: "PE", region: "Abruzzo", fullName: "Pescara, PE" },
  { name: "Teramo", province: "TE", region: "Abruzzo", fullName: "Teramo, TE" },

  // Molise
  { name: "Campobasso", province: "CB", region: "Molise", fullName: "Campobasso, CB" },
  { name: "Isernia", province: "IS", region: "Molise", fullName: "Isernia, IS" },

  // Calabria
  { name: "Catanzaro", province: "CZ", region: "Calabria", fullName: "Catanzaro, CZ" },
  { name: "Cosenza", province: "CS", region: "Calabria", fullName: "Cosenza, CS" },
  { name: "Crotone", province: "KR", region: "Calabria", fullName: "Crotone, KR" },
  { name: "Reggio Calabria", province: "RC", region: "Calabria", fullName: "Reggio Calabria, RC" },
  { name: "Vibo Valentia", province: "VV", region: "Calabria", fullName: "Vibo Valentia, VV" },

  // Basilicata
  { name: "Potenza", province: "PZ", region: "Basilicata", fullName: "Potenza, PZ" },
  { name: "Matera", province: "MT", region: "Basilicata", fullName: "Matera, MT" },

  // Sardegna
  { name: "Cagliari", province: "CA", region: "Sardegna", fullName: "Cagliari, CA" },
  { name: "Nuoro", province: "NU", region: "Sardegna", fullName: "Nuoro, NU" },
  { name: "Oristano", province: "OR", region: "Sardegna", fullName: "Oristano, OR" },
  { name: "Sassari", province: "SS", region: "Sardegna", fullName: "Sassari, SS" },
  { name: "Sud Sardegna", province: "SU", region: "Sardegna", fullName: "Sud Sardegna, SU" },

  // Valle d'Aosta
  { name: "Aosta", province: "AO", region: "Valle d'Aosta", fullName: "Aosta, AO" },

  // Umbria
  { name: "Perugia", province: "PG", region: "Umbria", fullName: "Perugia, PG" },
  { name: "Terni", province: "TR", region: "Umbria", fullName: "Terni, TR" },
];

// Function to search municipalities by name
export const searchMunicipalities = (query: string): Municipality[] => {
  if (!query.trim()) return [];
  
  const normalizedQuery = query.toLowerCase().trim();
  
  return italianMunicipalities.filter(municipality => 
    municipality.name.toLowerCase().includes(normalizedQuery) ||
    municipality.fullName.toLowerCase().includes(normalizedQuery) ||
    municipality.province.toLowerCase().includes(normalizedQuery)
  ).slice(0, 10); // Limit to 10 results for better UX
};

// Function to get municipality by full name
export const getMunicipalityByFullName = (fullName: string): Municipality | undefined => {
  return italianMunicipalities.find(municipality => 
    municipality.fullName.toLowerCase() === fullName.toLowerCase()
  );
}; 